import { MeshStandardMaterial, Color } from "three";

export const UnderwaterMaterial = async () => {
	// Standardmaterial erweitern
	const material = new MeshStandardMaterial({
		color: 0xffffff, // Grundfarbe, wird überschrieben
		transparent: true,
	});

	material.onBeforeCompile = (shader) => {
		// Uniforms für Farbverlauf und Transparenz hinzufügen
		shader.uniforms.minY = { value: -0.3 }; // Minimaler Y-Wert
		shader.uniforms.maxY = { value: 0.0 }; // Maximaler Y-Wert
		shader.uniforms.color1 = { value: new Color(0x2279cb) }; // Blau
		shader.uniforms.color2 = { value: new Color(0x0a2f52) }; // Dunkelblau

		// Vertex Shader: Y-Position an Fragment Shader übergeben
		shader.vertexShader = `
    varying float vY; // Lokale Y-Koordinate

    ${shader.vertexShader.replace(
			`#include <begin_vertex>`,
			`
      #include <begin_vertex>
      vY = position.y; // Lokale Y-Koordinate speichern
    `
		)}
  `;

		// Fragment Shader: Farbverlauf und Transparenz einfügen
		shader.fragmentShader = `
    uniform float minY;
    uniform float maxY;
    uniform vec3 color1;
    uniform vec3 color2;
    varying float vY;

    ${shader.fragmentShader.replace(
			`#include <dithering_fragment>`,
			`
      // Y-Koordinate normalisieren
      float normalizedY = (vY - minY) / (maxY - minY);
      normalizedY = clamp(normalizedY, 0.0, 1.0);

      // Farbverlauf berechnen
      vec3 gradientColor = mix(color1, color2, normalizedY);

      // Transparenz basierend auf umgekehrter Y-Normalisierung
      float alpha = normalizedY;

      // Originalfarbe mit Gradient und Transparenz überschreiben
      gl_FragColor = vec4(gradientColor, alpha);

      #include <dithering_fragment>
    `
		)}
  `;
	};

	return material;
};
